export default "__VITE_ASSET__WlTljEm___"